import '../firebase';
import axios from 'axios';
import { auth } from '../firebase';
import { API_BASE_URL } from '../config/routes';

// 20s: el backend corta a Spotify a los 10s (+8s del enriquecimiento de géneros en /search).
// Sin esto un request colgado deja el spinner para siempre.
const api = axios.create({ baseURL: API_BASE_URL, timeout: 20000 });

// promesa que se resuelve cuando Firebase Auth termina de cargar sesión
let authReadyPromise;
function waitForAuthReady() {
  if (authReadyPromise) return authReadyPromise;
  authReadyPromise = new Promise((resolve) => {
    // si ya hay user, resuelve de una
    if (auth.currentUser) return resolve();
    const unsub = auth.onAuthStateChanged(() => {
      unsub();
      resolve();
    });
  });
  return authReadyPromise;
}

api.interceptors.request.use(async (config) => {
  // espera a que Auth cargue (rehidrate) antes de leer currentUser
  await waitForAuthReady();

  const user = auth.currentUser;
  if (user) {
    const idToken = await user.getIdToken();
    config.headers.Authorization = `Bearer ${idToken}`;
  } else {
    // si la ruta no requiere auth, no rompas la request
    console.log('Sin idToken (ruta pública o aún no logueado)');
  }
  return config;
});

export default api;